import { createStore } from 'easy-peasy';

import modalDisplayModel from '../models/modalDisplayModel';
import mpqModel from '../models/mpqModel';
import combiningFinancesModel from '../components/Guides/CombiningFinances/combiningFinancesModel';

const storeModel = {
  modalDisplay: modalDisplayModel,
  mpq: mpqModel,
  combiningFinances: combiningFinancesModel
};

export default createStore(storeModel);
